<script lang="ts">
  export let href: string;

  async function handleClick() {
    try {
      const response = await fetch(href);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;

      link.download = 'downloaded_file';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setTimeout(() => window.URL.revokeObjectURL(url), 100);
    } catch (error) {
      console.error('Error handling file:', error);
    }
  }
</script>

<a
  class="dashboard-file"
  {href}
  download
  target="_blank"
  rel="noreferrer"
  on:click|preventDefault={handleClick}
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="feather feather-book"
    ><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" /><path
      d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"
    /></svg
  >
  <span><slot /></span>
</a>

<style lang="scss">
  .dashboard-file {
    display: flex;
    align-items: center;
    gap: 6px;
    height: 42px;
    border: 1.5px solid $color-medium-gray;
    border-radius: 13px;
    padding: 0 8px;
    transition: 0.3s ease all;
    cursor: pointer;
    svg {
      stroke: $color-medium-gray;
      transition: 0.3s ease all;
    }
    span {
      font-size: 14px;
      color: rgba($color-dark-gray, 0.8);
      font-weight: 500;
    }
    &:hover {
      background-color: $color-medium-gray;
      svg {
        stroke: rgba($color-dark-gray, 0.6);
      }
    }
  }
</style>
